var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 18.5978L18.6001 7.40234",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45065 13.0235C7.77972 12.9849 7.1082 13.0884 6.48009 13.3273C5.85197 13.5661 5.28144 13.935 4.80587 14.4096L2.40589 16.8087C1.50571 17.7085 1 18.9289 1 20.2014C1 20.8315 1.12416 21.4555 1.36538 22.0376C1.6066 22.6197 1.96017 23.1487 2.40589 23.5942C2.85161 24.0397 3.38076 24.3932 3.96312 24.6343C4.54548 24.8754 5.16965 24.9995 5.8 24.9995C7.07304 24.9995 8.29394 24.494 9.19411 23.5942L11.5941 21.1952C12.0689 20.7198 12.4379 20.1495 12.6769 19.5216C12.9159 18.8937 13.0194 18.2225 12.9808 17.5518",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5491 12.976C18.22 13.0146 18.8915 12.911 19.5196 12.6722C20.1477 12.4333 20.7183 12.0645 21.1939 11.5899L23.5939 9.19087C24.4941 8.29105 24.9998 7.07063 24.9998 5.7981C24.9998 4.52556 24.4941 3.30515 23.5939 2.40533C22.6937 1.50551 21.4728 1 20.1997 1C18.9267 1 17.7058 1.50551 16.8056 2.40533L14.4056 4.80436C13.9318 5.28032 13.5639 5.85086 13.3259 6.47867C13.0879 7.10649 12.9851 7.77745 13.0242 8.4477",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.c54e5d5b.svg";
export { ForwardRef as ReactComponent };